export default {
  computed: {
    authUser() {
      return this.$auth?.user;
    }
  },
  watch: {
    authUser() {
      this.$store.dispatch('profile/authUser/setUserUpdated', new Date().getTime());
    }
  }
};
